import {
  Clapperboard, Users, LogOut, LayoutGrid, PenLine, Wand2, Film, ArrowRight,
  Camera, Cloud, Sun, Plus, Trash2, Clock, CircleUser, Pencil, Image as ImageIcon,
  Sparkles, Volume2, Quote, Brain, Video, RefreshCw, ArrowLeft, Download,
  FileJson, Images, ChevronDown, ChevronUp,
} from "lucide-react";

// Shim that maps the Phosphor-style names/props used across the app to lucide-react.
// Strips the `weight` prop (lucide has no weight) so existing JSX works unchanged.
const wrap = (C) => {
  const Comp = ({ weight, ...props }) => <C {...props} />;
  return Comp;
};

export const FilmSlate = wrap(Clapperboard);
export const UsersThree = wrap(Users);
export const SignOut = wrap(LogOut);
export const SquaresFour = wrap(LayoutGrid);
export const PencilLine = wrap(PenLine);
export const MagicWand = wrap(Wand2);
export const FilmStrip = wrap(Film);
export { ArrowRight, Camera, Cloud, Sun, Plus, Clock, Brain, ArrowLeft };
export const Trash = wrap(Trash2);
export const UserCircle = wrap(CircleUser);
export const PencilSimple = wrap(Pencil);
export const ImageSquare = wrap(ImageIcon);
export const Sparkle = wrap(Sparkles);
export const SpeakerHigh = wrap(Volume2);
export const Quotes = wrap(Quote);
export const FilmReel = wrap(Video);
export const ArrowsClockwise = wrap(RefreshCw);
export const DownloadSimple = wrap(Download);
export const FileJs = wrap(FileJson);
export const ImagesSquare = wrap(Images);
export const CaretDown = wrap(ChevronDown);
export const CaretUp = wrap(ChevronUp);
